import { render, staticRenderFns } from "./AffectPricingNotificationModal.vue?vue&type=template&id=aae7e4f4&"
import script from "./AffectPricingNotificationModal.vue?vue&type=script&lang=js&"
export * from "./AffectPricingNotificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports